<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：产品分类-添加
    -->
  <el-dialog title="添加等级" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="form" :rules="formRules" ref="form">
      <el-form-item label="名称" prop="name" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="用户比例" prop="userScale" :label-width="formLabelWidth">
        <el-input v-model.number="form.userScale" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="技师比例" prop="waiterScale" :label-width="formLabelWidth">
        <el-input v-model.number="form.waiterScale" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="用户二级比例" prop="twoUserScale" :label-width="formLabelWidth">
        <el-input v-model.number="form.twoUserScale" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="技师二级比例" prop="twoWaiterScale" :label-width="formLabelWidth">
        <el-input v-model.number="form.twoWaiterScale" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="是否默认等级" :label-width="formLabelWidth">
        <el-radio-group v-model="form.isDefault">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="排序" prop="sort" :label-width="formLabelWidth">
        <el-input v-model.number="form.sort" autocomplete="off"></el-input>
      </el-form-item>
      <!-- <el-form-item label="是否默认等级" prop="isDefault" :label-width="formLabelWidth">
        <template slot-scope="scope">
          <el-switch :value="changestatus(scope.row.isDefault)" active-color="#13ce66" inactive-color="#ccc" active-text="开启" inactive-text="关闭" @change="changeSwitch($event ,scope.row)">
          </el-switch>
        </template>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addUser" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>

</template>

<script>
import PromotionApi from "@/api/promotion.js";

export default {
  data() {
    return {
      form: {
        waiterScale: "",
        name: "",
        userScale: "",
        isDefault: 0,
        sort: 100,
        twoUserScale: "",
        twoWaiterScale: ""
      },
      formRules: {
        name: [
          {
            required: true,
            message: "请输入等级名称",
            trigger: "blur"
          }
        ],
        userScale: [
          {
            required: true,
            message: "请输入用户比例",
            trigger: "blur"
          }
        ],
        waiterScale: [
          {
            required: true,
            message: "请输入技师比例",
            trigger: "blur"
          }
        ],
        twoUserScale: [
          {
            required: true,
            message: "请输入用户二级比例",
            trigger: "blur"
          }
        ],
        twoWaiterScale: [
          {
            required: true,
            message: "请输入技师二级比例",
            trigger: "blur"
          }
        ],
        sort: [
          {
            required: true,
            message: "排序不能为空"
          },
          {
            type: "number",
            message: "排序必须为数字"
          }
        ]
      },
      /*左边长度*/
      formLabelWidth: "120px",
      /*是否显示*/
      dialogVisible: false,
      loading: false,
      /*是否上传图片*/
      isupload: false
    };
  },
  props: ["open_add", "addform"],
  created() {
    this.dialogVisible = this.open_add;
  },
  methods: {
    /*添加用户*/
    addUser() {
      let self = this;
      let params = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          PromotionApi.PromotionGradeadd(params)
            .then(data => {
              self.loading = false;
              self.$message({
                message: "添加成功",
                type: "success"
              });
              self.dialogFormVisible(true);
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false
        });
      }
    }
  }
};
</script>

<style>
.img {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/promotion/promoter/Add.vue